// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._1yNKA{display:inline-block;color:#fff;cursor:pointer}._3RFLs{display:block}._3RFLs path[fill]{fill:#00d8ae}._17DvN{display:block}._17DvN path[fill]{fill:#231815}", ""]);
// Exports
exports.locals = {
	"NAVBAR_HEIGHT": "72",
	"TABLET_WIDTH": "768",
	"DESKTOP_WIDTH": "1024",
	"WIDE_DESKTOP_WIDTH": "1440",
	"root": "_1yNKA",
	"savedIcon": "_3RFLs",
	"normalIcon": "_17DvN"
};
module.exports = exports;
